import "../styles/SectionGrid.scss";

function SectionGrid({ children }: any) {
    return <div className="section-grid">{children}</div>;
}

export default SectionGrid;
